module.exports = __webpack_public_path__ + "static/media/calculator.4631d03c.svg";